import React from "react";
import PropTypes from "prop-types";

/**
 * A generic Skeleton List component for loading states.
 * This component renders a list of skeleton items with a gradient background and pulse animations.
 *
 * @param {Object} props - The component props.
 * @param {string} [props.className=""] - Additional CSS classes to apply to the container.
 * @param {number} [props.count=1] - The number of skeleton items to render.
 * @param {string} [props.itemClassName=""] - Additional CSS classes to apply to each skeleton item.
 * @param {Object} [props.itemStyle={}] - Additional inline styles to apply to each skeleton item.
 * @returns {React.ReactElement} The SkeletonList component.
 */
const SkeletonList = ({ className = "", count = 1, itemClassName = "", itemStyle = {} }) => {
  const skeletonItems = Array.from({ length: count }, (_, index) => (
    <div
      key={`skeleton-item-${index}`}
      className={`animate-[pulse_0.6s_ease-in-out_infinite] rounded-t-lg bg-gradient-to-r from-[#F5F5F5] via-[#EEE] to-[#E0E0E0] ${itemClassName}`}
      style={itemStyle}
    />
  ));

  return <div className={className}>{skeletonItems}</div>;
};

SkeletonList.propTypes = {
  className: PropTypes.string,
  count: PropTypes.number,
  itemClassName: PropTypes.string,
  itemStyle: PropTypes.object,
};

export default SkeletonList;
